import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Roba } from './roba';

@Component({
  selector: 'app-roba',
  templateUrl: './roba.component.html'
})
export class RobaComponent extends BaseModalContainer<Roba> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Roba>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
